import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class SponsorsService {
  static TIME_FRAMES = ['ALL', 'LAST_MONTH', 'LAST_YEAR']

  constructor() {
    this.endpoints = {
      ...createPrefix('/sponsor', {
        sponsors: '/sponsors',
        sponsor: '/sponsor',
        search: '/sponsors/search',
        reportDonations: '/report/donations',
      }),
      ...createPrefix('/sponsor/transaction', {
        transHistory: '/history',
      }),
    }
  }

  static create() {
    return new SponsorsService()
  }

  async getListOfSponsors(params) {
    const servicePath = this.endpoints.sponsors()
    const { data } = await axios.get(servicePath, {
      params: {
        // remove?
        types: 'LIMITED_CONTRIBUTION',
        ...params,
      },
    })
    return data
  }

  async getSponsorTransHistory(params) {
    const servicePath = this.endpoints.transHistory()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async downloadDonations(year) {
    const servicePath = this.endpoints.reportDonations()
    const response = await axios.get(`${servicePath}/${year}`, {
      responseType: 'blob',
    })
    const fileBlob = new Blob([response.data], { type: 'application/pdf' })
    const link = document.createElement('a')
    const url = window.URL.createObjectURL(fileBlob)
    link.href = url
    link.setAttribute('download', `Donations_${year}.pdf`)
    document.body.appendChild(link)
    // Programmatically click the link to trigger the download
    link.click()
    link.parentNode.removeChild(link)
    window.URL.revokeObjectURL(url)
  }
}
